import request from '@/utils/request'
import ENDPOINT from '@/config/endpoint'

export function getArtifactById(params) {
  return request({
    url: ENDPOINT.ARTIFACT_PUBLIC,
    method: 'get',
    params
  })
}

export function getClassification(params) {
  return request({
    url: ENDPOINT.ARTIFACT_CLASSIFICATION_PUBLIC,
    method: 'get',
    params
  })
}

export function listPlaceArtifacts(params) {
  return request({
    url: ENDPOINT.LIST_PLACE_ARTIFACT_PUBLIC,
    method: 'get',
    params
  })
}
